import React from 'react';

import {PushNotificationRemoveEvent} from 'src/components/remove-event/push-notification-remove-event';
import {EventDetailInfo} from 'src/openapi/models/EventDetailInfo';

import {Button} from '@pb/kit-component-button';
import {Icons} from '@pb/kit-component-icon';
import {usePushNotification} from '@pb/kit-component-push-notification';

type Props = {
    eventDetailInfo: EventDetailInfo,
};

export const RemoveEvent = ({eventDetailInfo}: Props) => {
    const {onCreateNote, onCloseNote} = usePushNotification();

    const onRemove = () => {
        if (!eventDetailInfo.id) {
            return;
        }
        onCreateNote({
            id: `${eventDetailInfo.id}`,
            body: () => (
                <PushNotificationRemoveEvent
                    {...{
                        id: eventDetailInfo.id || 0,
                        code: eventDetailInfo.code,
                        source: eventDetailInfo.source,
                        onClose: onCloseNote,
                    }}
                />
            ),
            buttonProps: {icon: Icons.CLOSE},
            autoHideTimeout: 10000,
        });
    };

    return (<Button colorVariant="ERROR" onClick={onRemove} variant="Type.SECONDARY">Delete</Button>);
};
